import './App.css';
import NavBar from './components/NavBar';
import Router from './components/Routes';
import "antd/dist/antd.css";

function App() {
  return (
    <>
    <NavBar />
    <Router />
    </>
  );
}

export default App;
